import React, { useRef } from 'react';

function LazyLoadImage(props) {
    const containerRef = useRef(null);

    const containerStyle = props.width
        ? {
            width: `${props.width}px`,
            minWidth: `${props.width}px`,
            maxWidth: `${props.width}px`,
            flex: `0 0 ${props.width}px`,
            overflow: 'hidden',
            position: 'relative'
        }
        : {};

    return (
        <div
            ref={containerRef}
            id={props.id}
            className={props.containerClassName}
            style={{ ...containerStyle, position: 'relative' }}
        >
            {!props.isLoading && (
                <img
                    src={props.path || ''}
                    alt="ZoneHistory"
                    className={props.className}
                    pos={props.pos}
                    onClick={props.onClick}
                    draggable={false}
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                />
            )}

            {props.isLoading && (
                <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    minHeight: '60px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(0,0,0,0.35)'
                }}>
                    <div className="spinner-border spinner-border-sm text-light" role="status" />
                </div>
            )}

            {props.content}
        </div>
    );
}

export default LazyLoadImage;